import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import img from "./all_bg.jpg";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function Personal_Info() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    id: null,
    salutation: "",
    name: "",
    affiliation_nature: "",
    specialty: "",
    faculty_school: "",
    academic_rank: "",
    email: "",
  });

  const [loading, setLoading] = useState(true);

  const [otherSpecialty, setOtherSpecialty] = useState("");
  const [otherAcademicRank, setOtherAcademicRank] = useState("");

  const specialtiesList = [
    "Accounting",
    "Actuarial Science",
    "Arts Administration",
    "Behavioral Science/ Organizational Behavior",
    "Business Communication",
    "Business Education",
    "Business Ethics - incl Corporate Social Responsibility",
    "Business Law/ Legal Environment",
    "Computer or Management Information Systems",
    "Consulting",
    "Data Analytics",
    "E-Business - incl E-commerce",
    "Economics/ Managerial Economics",
    "Energy Management",
    "Entrepreneurship/ Small Business Admin Arts Administration",
    "Finance - incl Banking",
    "General Business",
    "Health Services/ Hospital Admin",
    "Hotel/ Restaurant/ Tourism",
    "HR Mgt - incl Personnel & Ind/Labor Relations",
    "Insurance",
    "International Business",
    "Leadership",
    "Management",
    "Manufacturing and Technology Management",
    "Marketing",
    "Operations Research",
    "Production/Operations Management",
    "Public Administration",
    "Quantitative Methods",
    "Real Estate",
    "Sports Management",
    "Statistics",
    "Strategic Management",
    "Supply Chain/ Transport/ Logistics",
    "Taxation",
  ];

  const academicRankList = [
    "Professor",
    "Associate Professor",
    "Assistant Professor",
    "Senior Lecturer",
    "Lecturer",

    "Visiting Faculty",
  ];

  // ================= Fetch Personal Info =================
  useEffect(() => {
    const fetchPersonalInfo = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) return navigate("/login");

        const res = await fetch(
          "https://api.bbsfacultyprofile.com/api/personal_information",
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        if (!res.ok) throw new Error("Unauthorized");

        const data = await res.json();
        if (data && data.length > 0) {
          const info = data[0];

          const isOtherSpecialty =
            info.specialty && !specialtiesList.includes(info.specialty);
          const isOtherRank =
            info.academic_rank &&
            !academicRankList.includes(info.academic_rank);

          setFormData({
            id: info.id,
            salutation: info.salutation || "",
            name: info.name || "",
            affiliation_nature: info.affiliation_nature || "",
            specialty: isOtherSpecialty ? "Other" : info.specialty || "",
            faculty_school: info.faculty_school || "",
            academic_rank: isOtherRank ? "Other" : info.academic_rank || "",
            email: info.email || "",
          });

          if (isOtherSpecialty) setOtherSpecialty(info.specialty);
          if (isOtherRank) setOtherAcademicRank(info.academic_rank);
        }
      } catch (err) {
        console.error("Fetch error:", err);
        toast.error("Session expired. Please login again.");
        navigate("/login");
      } finally {
        setLoading(false);
      }
    };

    fetchPersonalInfo();
  }, [navigate]);

  // ================= Handle change =================
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "specialty") {
      setFormData((prev) => ({ ...prev, specialty: value }));
      if (value !== "Other") setOtherSpecialty("");
    } else if (name === "academic_rank") {
      setFormData((prev) => ({ ...prev, academic_rank: value }));
      if (value !== "Other") setOtherAcademicRank("");
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleOtherSpecialtyChange = (e) => {
    const value = e.target.value;

    if (
      specialtiesList.some((spec) => spec.toLowerCase() === value.toLowerCase())
    ) {
      toast.error("This specialty already exists in the dropdown!");
      return;
    }

    setOtherSpecialty(value);
  };

  // ================= Submit =================
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.id) {
      toast.error("Cannot update: missing record ID");
      return;
    }

    try {
      const token = localStorage.getItem("token");
      if (!token) return navigate("/login");

      const res = await fetch(
        `https://api.bbsfacultyprofile.com/api/personal_information/${formData.id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            salutation: formData.salutation,
            name: formData.name,
            affiliation_nature: formData.affiliation_nature,
            faculty_school: formData.faculty_school,
            academic_rank:
              formData.academic_rank === "Other"
                ? otherAcademicRank
                : formData.academic_rank,
            email: formData.email,
            specialty:
              formData.specialty === "Other"
                ? otherSpecialty
                : formData.specialty,
          }),
        }
      );

      const result = await res.json();
      if (!res.ok) throw new Error(result.message || "Update failed");

      toast.success("Personal information updated successfully!");
    } catch (err) {
      console.error("Save error:", err);
      toast.error(err.message || "Failed to update personal information.");
    }
  };

  if (loading)
    return (
      <p style={{ textAlign: "center", marginTop: "100px" }}>
        Loading personal information...
      </p>
    );

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "40px 20px",
        fontFamily: "Arial, sans-serif",
        backgroundImage: `url(${img})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <ToastContainer position="top-center" autoClose={3000} />

      <div
        style={{
          width: "100%",
          maxWidth: "800px",
          background: "#fff",
          padding: "30px 40px",
          borderRadius: "10px",
          boxShadow: "0 0 12px rgba(0,0,0,0.1)",
        }}
      >
        <h2
          style={{
            textAlign: "center",
            color: "#1e3a8a",
            marginBottom: "30px",
          }}
        >
          Edit Personal Information
        </h2>

        <form
          onSubmit={handleSubmit}
          style={{ display: "flex", flexDirection: "column", gap: "15px" }}
        >
          {/* Salutation */}
          <div>
            <label style={{ fontWeight: "bold" }}>Salutation</label>
            <select
              name="salutation"
              value={formData.salutation}
              onChange={handleChange}
              required
              style={inputStyle}
            >
              <option value="">Select</option>
              <option value="Dr.">Dr.</option>
              <option value="Mr.">Mr.</option>
              <option value="Mrs.">Mrs.</option>
              <option value="Ms.">Ms.</option>
            </select>
          </div>

          {/* Name */}
          <div>
            <label style={{ fontWeight: "bold" }}>Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              style={inputStyle}
            />
          </div>

          {/* Affiliation */}
          <div>
            <label style={{ fontWeight: "bold" }}>
              Nature of Affiliation with BBS
            </label>
            <select
              name="affiliation_nature"
              value={formData.affiliation_nature}
              onChange={handleChange}
              required
              style={inputStyle}
            >
              <option value="">Select</option>
              <option value="Full-time">Full-time</option>
              <option value="Part-time/Adjunct">Part-time/Adjunct</option>
            </select>
          </div>

          {/* Specialty */}
          <div>
            <label style={{ fontWeight: "bold" }}>Specialty</label>
            <select
              name="specialty"
              value={formData.specialty}
              onChange={handleChange}
              required
              style={inputStyle}
            >
              <option value="">Select</option>
              {specialtiesList.map((spec) => (
                <option key={spec} value={spec}>
                  {spec}
                </option>
              ))}
              <option value="Other">Other</option>
            </select>

            {formData.specialty === "Other" && (
              <input
                type="text"
                placeholder="Enter specialty"
                value={otherSpecialty}
                onChange={handleOtherSpecialtyChange}
                style={{ ...inputStyle, marginTop: "10px" }}
                required
              />
            )}
          </div>

          {/* Faculty / School */}
          <div>
            <label style={{ fontWeight: "bold" }}>
              Faculty / School / Department
            </label>
            <input
              type="text"
              name="faculty_school"
              value={formData.faculty_school}
              onChange={handleChange}
              required
              style={inputStyle}
            />
          </div>

          {/* Academic Rank */}
          <div>
            <label style={{ fontWeight: "bold" }}>Academic Rank</label>
            <select
              name="academic_rank"
              value={formData.academic_rank}
              onChange={handleChange}
              required
              style={inputStyle}
            >
              <option value="">Select</option>
              {academicRankList.map((rank) => (
                <option key={rank} value={rank}>
                  {rank}
                </option>
              ))}
              <option value="Other">Other</option>
            </select>

            {formData.academic_rank === "Other" && (
              <input
                type="text"
                placeholder="Enter academic rank"
                value={otherAcademicRank}
                onChange={(e) => setOtherAcademicRank(e.target.value)}
                style={{ ...inputStyle, marginTop: "10px" }}
                required
              />
            )}
          </div>

          {/* Email */}
          <div>
            <label style={{ fontWeight: "bold" }}>Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              style={inputStyle}
              placeholder="example@bracu.ac.bd"
            />
          </div>

          <button type="submit" style={btnPrimary}>
            Update Personal Information
          </button>
        </form>

        <button
          onClick={() => navigate("/dashboard")}
          style={{ ...btnSecondary, marginTop: "20px" }}
        >
          Back to Dashboard
        </button>
      </div>
    </div>
  );
}

// ================= Styles =================
const inputStyle = {
  width: "100%",
  padding: "10px",
  marginTop: "5px",
  border: "1px solid #ccc",
  borderRadius: "6px",
  fontSize: "14px",
};

const btnPrimary = {
  background: "#3b82f6",
  color: "white",
  padding: "12px",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer",
  fontWeight: "bold",
  fontSize: "14px",
};

const btnSecondary = {
  background: "#1e3a8a",
  color: "white",
  padding: "10px 20px",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer",
  fontWeight: "bold",
  fontSize: "14px",
};
